import { z } from 'zod'

import { baseStructuredSchema } from '@/pages/instruments/new-instrument/schemas/shared/base-structured.schema'
import { contractSideSchema } from '@/pages/instruments/new-instrument/schemas/shared/contract-side.schema'
import { contractTypeSchema } from '@/pages/instruments/new-instrument/schemas/shared/contract-type.schema'
import { knockdownInputLevelSchema } from '@/pages/instruments/new-instrument/schemas/shared/knockdown-input-level.schema'

export const vanillaSpreadSchema = baseStructuredSchema.extend({
  instrument_type: z.literal('vanilla-spread'),

  contract_side: contractSideSchema,
  contract_type: contractTypeSchema,
  participation_rate: z.number(),

  knockdown_input_level: knockdownInputLevelSchema,
})

export type VanillaSpreadSchemaType = z.infer<typeof vanillaSpreadSchema>
